import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Khushi Gandhi. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
